var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_26521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.09961C9.39497 9.09961 10.8384 9.46914 11.959 10.2666C13.1067 11.083 13.9004 12.344 13.9004 14C13.9004 14.2387 13.8055 14.4679 13.6367 14.6367C13.4679 14.8055 13.2387 14.9004 13 14.9004C12.7613 14.9004 12.5321 14.8055 12.3633 14.6367C12.1945 14.4679 12.0996 14.2387 12.0996 14C12.0996 12.9893 11.6435 12.2501 10.916 11.7334C10.1616 11.1969 9.1061 10.9004 8 10.9004C6.89491 10.9004 5.83836 11.1969 5.08398 11.7334C4.35655 12.2511 3.90039 12.9902 3.90039 14C3.90039 14.2387 3.8055 14.4679 3.63672 14.6367C3.46794 14.8055 3.23869 14.9004 3 14.9004C2.76131 14.9004 2.53206 14.8055 2.36328 14.6367C2.1945 14.4679 2.09961 14.2387 2.09961 14C2.09961 12.344 2.89331 11.083 4.04102 10.2666C5.16158 9.46915 6.60602 9.09961 8 9.09961ZM8 1.09961C8.90174 1.09961 9.76667 1.45808 10.4043 2.0957C11.0419 2.73333 11.4004 3.59826 11.4004 4.5C11.4004 5.40174 11.0419 6.26667 10.4043 6.9043C9.76667 7.54192 8.90174 7.90039 8 7.90039C7.09826 7.90039 6.23333 7.54192 5.5957 6.9043C4.95808 6.26667 4.59961 5.40174 4.59961 4.5C4.59961 3.59826 4.95808 2.73333 5.5957 2.0957C6.23333 1.45808 7.09826 1.09961 8 1.09961ZM8 2.90039C7.57565 2.90039 7.16822 3.06811 6.86816 3.36816C6.56811 3.66822 6.40039 4.07565 6.40039 4.5C6.40039 4.92435 6.56811 5.33178 6.86816 5.63184C7.16822 5.93189 7.57565 6.09961 8 6.09961C8.42435 6.09961 8.83178 5.93189 9.13184 5.63184C9.43189 5.33178 9.59961 4.92435 9.59961 4.5C9.59961 4.07565 9.43189 3.66822 9.13184 3.36816C8.83178 3.06811 8.42435 2.90039 8 2.90039Z",
    fill: "currentFill",
    stroke: "none",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_26521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.93aceb1651e0382721453bed1f3a36c1.svg";
export { ForwardRef as ReactComponent };